import { render, staticRenderFns } from "./ProfileDeleteAttention.vue?vue&type=template&id=46252d1e&scoped=true&"
import script from "./ProfileDeleteAttention.vue?vue&type=script&lang=js&"
export * from "./ProfileDeleteAttention.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDeleteAttention.vue?vue&type=style&index=0&id=46252d1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46252d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('46252d1e', component.options)
    } else {
      api.reload('46252d1e', component.options)
    }
    module.hot.accept("./ProfileDeleteAttention.vue?vue&type=template&id=46252d1e&scoped=true&", function () {
      api.rerender('46252d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/delete_attention/ProfileDeleteAttention.vue"
export default component.exports